module.exports = __webpack_public_path__ + "nc_static/media/deviceCertificate.51b3683d.svg";